import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoints } from 'common/hooks';
import { WarningCircleIcon } from '@fronton/icons-react';
import { Snackbar, Snack, useSnackbar, SnackbarProvider } from 'fronton-react';

type Props = {
  id: number;
};

export const Error = ({ ...props }: Props) => (
  <SnackbarProvider>
    <SnackImpl {...props} />
  </SnackbarProvider>
);

function SnackImpl({ id }: Props) {
  const { mobile, tablet } = useBreakpoints() || {
    mobile: false,
    tablet: false,
  };

  const isMobile = mobile || tablet;

  const { t } = useTranslation();
  const { state, addSnack, removeSnack } = useSnackbar();

  useEffect(() => {
    const snackId = `snack-${id}`;
    addSnack({
      id: snackId,
    });

    return () => {
      removeSnack(snackId);
    };
  }, [addSnack, removeSnack, id]);

  return (
    <Snackbar verticalPosition={isMobile ? 'top' : 'bottom'}>
      {state.map((snack: { id: string }) => {
        const snackId = snack.id;

        return (
          <Snack
            autoHideTimer={5000}
            key={snackId}
            id={snackId}
            variant="error"
            data-qa={`pagination-error-${snackId}`}
            icon={<WarningCircleIcon type="outline" size="l" color="brand-invert" />}
            header={t('reviews.ui.paginagion.error.header')}
            paragraph={t('reviews.ui.paginagion.error.paragraph')}
          ></Snack>
        );
      })}
    </Snackbar>
  );
}
